
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 25 7\" id=\"more_icon_jax_27db0c2b0c46601acb8f467fa7f05003\" ><g transform=\"translate(1 1)\" fill=\"none\"><circle cx=\"20.5\" cy=\"2.5\" r=\"2.5\"/><circle cx=\"11.5\" cy=\"2.5\" r=\"2.5\"/><circle cx=\"2.5\" cy=\"2.5\" r=\"2.5\"/></g></symbol>";
module.exports = sprite.add(image, "more_icon_jax_27db0c2b0c46601acb8f467fa7f05003");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/more_icon.svg
// module id = 1423
// module chunks = 1